import { render, staticRenderFns } from "./DeliveryTemplate.vue?vue&type=template&id=59d5d61b&scoped=true&"
import script from "./DeliveryTemplate.vue?vue&type=script&lang=ts&"
export * from "./DeliveryTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryTemplate.vue?vue&type=style&index=0&id=59d5d61b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d5d61b",
  null
  
)

export default component.exports